import { useState } from 'react'
import { Menu, MenuButton, MenuItem } from '@szhsin/react-menu'

import Tooltip from 'common/components/Tooltip'
import { Download } from 'common/icons'
import useDownloadFile, {
  FILES_TYPES,
} from 'features/unifiedFlow/contentPage/hooks/useDownloadFile'

type Props = {
  tooltipPlacement: 'top' | 'bottom' | 'left' | 'right'
}

const ExportMenuButton = ({ tooltipPlacement }: Props) => {
  const { downloadFile } = useDownloadFile()
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  return (
    <Menu
      menuClassName="cursor-pointer"
      align="start"
      direction="left"
      portal={true}
      viewScroll="close"
      data-testid="export-menu"
      onMenuChange={({ open }) => setIsMenuOpen(open)}
      menuButton={() => (
        <MenuButton aria-label="Export" data-testid="export-button">
          <Tooltip
            overlay="Download variants"
            placement={tooltipPlacement}
            show={!isMenuOpen}
          >
            <Download
              isDefaultColor={false}
              className="text-gold-600 w-6 h-6 hover:text-gold-700"
            />
          </Tooltip>
        </MenuButton>
      )}
    >
      <MenuItem key="1" onClick={() => downloadFile(FILES_TYPES.CSV)}>
        Export all: CSV
      </MenuItem>
      <MenuItem key="2" onClick={() => downloadFile(FILES_TYPES.XLS)}>
        Export all: XLS
      </MenuItem>
    </Menu>
  )
}

export default ExportMenuButton
